import { render, staticRenderFns } from "./WeddingDetails.vue?vue&type=template&id=66a088b0&scoped=true&"
import script from "./WeddingDetails.vue?vue&type=script&lang=ts&"
export * from "./WeddingDetails.vue?vue&type=script&lang=ts&"
import style0 from "./WeddingDetails.vue?vue&type=style&index=0&id=66a088b0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a088b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow,VSpacer})
